import cn from "classnames";
import Styles from "./Text.module.scss";

type TextTransform = "uppercase" | "lowercase" | "capitalize" | "sentenceCase";
type TextChild = JSX.Element | string | number;

export interface TextProps {
  align?: "left" | "center" | "right";
  color?: string;
  size?: string;
  textTransform?: TextTransform;
  weight?: string;
  block?: boolean;
  children: TextChild | undefined;
  className?: string;
  noWrap?: boolean;
  bottomMargin?: boolean;
  unselectable?: boolean;
  labelFor?: string;
  id?: string;
  priority?: number;
}

export const Text = ({
  align = "left",
  color = "offBlack",
  size = "base",
  textTransform = undefined,
  weight = "regular",
  block = false,
  children,
  className,
  noWrap = false,
  unselectable = false,
  bottomMargin = false, // Useful for titles
  labelFor,
  priority,
}: TextProps) => {
  const Tag = block ? "div" : "span";
  const classes = cn(
    Styles.text,
    Styles[align],
    Styles[color],
    Styles[size],
    Styles[weight],
    textTransform && Styles[textTransform],
    {
      [Styles.noWrap]: noWrap,
      [Styles.unselectable]: unselectable,
      [Styles.bottomMargin]: bottomMargin,
    },
    className
  );

  return (
    <Tag className={classes}>
      {labelFor && <label htmlFor={labelFor}>{children}</label>}
      {!labelFor && <>{children}</>}
    </Tag>
  );
};
